module.exports = __webpack_public_path__ + "static/media/San.317c15a1.jpg";